import React, { useState, useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { Row, Col, Button, Form, Select, Spin, Icon } from 'antd'
import Iframe from 'react-iframe'
import { Formik } from 'formik'
import * as yup from 'yup'
import LangContext from 'modules/shared/context/langContext'
import { GeneralStyledContent } from '../../../../styled/common-styled'

const FormItem = Form.Item
const { Option } = Select

function Index({ profile, accessToken }) {
  const [vehicleList, setVehicleList] = useState([])
  const [url, setUrl] = useState('')
  const [loading, setLoading] = useState(true)
  const [imei, setImei] = useState([])
  const formikRef = useRef()

  const initialValues = { plate_no: '' }

  useEffect(() => {
    getVehicle()
    getVehicleList()
  }, [])

  useEffect(() => {
    const search = window.location.search
    const params = new URLSearchParams(search)
    const vehicle_id = parseInt(params.get('vehicle_id'))
    if (!!vehicle_id) {
      const vehicle = vehicleList.find(item => item.id === vehicle_id)
      if (!!vehicle) {
        onSubmit(vehicle.id)
        if (formikRef.current)
          formikRef.current.setFieldValue('plate_no', vehicle.id)
      }
    }
  }, [vehicleList])

  const getVehicle = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/video-playback`,
        { vehicle_visibility: profile.vehicle_visibility },
        { headers: { Authorization: `Bearer ${accessToken}` } },
      )
      setVehicleList(res.data.data || [])
    } catch (err) {
      console.error('[getVehicle]', err.message)
    } finally {
      setLoading(false)
    }
  }

  const onSubmit = async id => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/video-playback/${id}`,
        {},
        { headers: { Authorization: `Bearer ${accessToken}` } },
      )
      setUrl(res.data.data || [])
    } catch (err) {
      console.error('[onSubmit]', err.message)
    }
  }

  const getVehicleList = async () => {
    const idprocess = 'web' + new Date().getTime()

    const {
      data: { message },
    } = await axios.get(
      `https://${process.env.REACT_APP_WEBSOCKET}/getAllConnection?idprocess=` +
        idprocess,
    )
    setImei(message.split(','))
  }

  useEffect(() => {
    if (formikRef.current && formikRef.current.state.values.plate_no !== '') {
      setInterval(() => {
        getVehicleList()
      }, 5000)
    } else {
      clearInterval()
    }

    return () => {
      clearInterval()
    }
  }, [formikRef.current && formikRef.current.state.values.plate_no])

  return (
    <LangContext.Consumer>
      {i18n => (
        <GeneralStyledContent>
          <Spin spinning={loading}>
            <Row gutter={24}>
              <Col span={24}>
                <span className="semi-bold-16" style={{ color: 'black' }}>
                  {i18n.h.honeytoastplayback}
                </span>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Formik
                  ref={formikRef}
                  initialValues={initialValues}
                  validationSchema={yup.object().shape({
                    plate_no: yup
                      .string()
                      .required(i18n.p.pleaseSelectVehicleRegistration),
                  })}
                  onSubmit={values => onSubmit(values.plate_no)}
                  render={({
                    values,
                    errors,
                    touched,
                    handleSubmit,
                    setFieldValue,
                  }) => (
                    <Form onSubmit={handleSubmit}>
                      <Row>
                        <Col
                          span={2}
                          style={{
                            textAlign: 'right',
                            top: '10px',
                            marginRight: '5px',
                          }}
                        >
                          <span className="regular-bold-14">
                            {i18n.p.plateNoVehicleCode}
                          </span>
                          <span style={{ color: 'red' }}>*</span>
                        </Col>
                        <Col span={4}>
                          <FormItem
                            validateStatus={
                              touched.plate_no && errors.plate_no && 'error'
                            }
                            help={touched.plate_no && errors.plate_no}
                          >
                            <Select
                              showSearch
                              optionFilterProp="children"
                              onChange={e => setFieldValue('plate_no', e)}
                              filterOption={(input, option) =>
                                option.props.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              value={values.plate_no}
                            >
                              {vehicleList.map(item => (
                                <Option key={item.id} value={item.id}>
                                  {item.plate_no}
                                </Option>
                              ))}
                            </Select>
                          </FormItem>
                        </Col>

                        <Col
                          span={1}
                          style={{
                            alignContent: 'center',
                            textAlign: 'center',
                            height: 40,
                          }}
                        >
                          {values.plate_no &&
                            (imei.includes(
                              vehicleList.find(
                                vehicle => vehicle.id === values.plate_no,
                              )
                                ? vehicleList.find(
                                    vehicle => vehicle.id === values.plate_no,
                                  ).hardware_id
                                : '',
                            ) ? (
                              <Icon
                                type="car"
                                theme="twoTone"
                                twoToneColor="#00BF06"
                              />
                            ) : (
                              <Icon
                                type="car"
                                theme="twoTone"
                                twoToneColor="#c91c1c"
                              />
                            ))}
                        </Col>

                        <Col span={2} style={{ marginLeft: '10px' }}>
                          <FormItem>
                            <Button htmlType="submit" type="primary">
                              {i18n.a.apply}
                            </Button>
                          </FormItem>
                        </Col>
                      </Row>
                    </Form>
                  )}
                />
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Iframe
                  url={url}
                  width="100%"
                  height={window.innerHeight - 250 + 'px'}
                  allowFullScreen
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  frameBorder={4}
                  loading="lazy"
                />
              </Col>
            </Row>
          </Spin>
        </GeneralStyledContent>
      )}
    </LangContext.Consumer>
  )
}

const mapStateToProps = ({ auth: { profile, accessToken } }) => ({
  profile,
  accessToken,
})

export default connect(mapStateToProps)(Index)
